"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxSaveGlobalApplicationSignaturePreferencesArgs = void 0;
var HxStringPair_1 = require("./HxStringPair");
function serializeHxSaveGlobalApplicationSignaturePreferencesArgs(_arg) {
    var output = [];
    output.push(_arg.shouldSetApplyAllSettings);
    output.push(_arg.globalApplicationSettingsMap);
    output.push(_arg.shouldSetSignatureHtml);
    output.push(new Buffer(_arg.signatureHtml).toString('base64'));
    output.push(_arg.shouldSetSignatureImages);
    var signatureImagesOutput = [];
    _arg.signatureImages.forEach(function (item) { return signatureImagesOutput.push(HxStringPair_1.serializeHxStringPair(item)); });
    output.push(signatureImagesOutput);
    output.push(_arg.shouldSetIsSignatureUserModified);
    output.push(_arg.isSignatureUserModified);
    output.push(_arg.shouldSetIsSignatureEnabled);
    output.push(_arg.isSignatureEnabled);
    return output;
}
exports.serializeHxSaveGlobalApplicationSignaturePreferencesArgs = serializeHxSaveGlobalApplicationSignaturePreferencesArgs;
